import { IFormErrors } from '@interfaces/IFormsErrors';
import { IUser } from '@interfaces/IUser';
import { Action } from '@ngrx/store';

export enum EProfileViewActions {
  GetProfileRequest = '[User] Get Profile Request',
  GetProfileSuccess = '[User] Get Profile Success',
  GetProfileFailure = '[User] Get Profile Failure',
  ClearGetProfile = '[User] Clear Get Profile',
  UpdateProfileAvatar = '[User] Update Profile Avatar',
}

export class GetProfileRequest implements Action {
  public readonly type = EProfileViewActions.GetProfileRequest;

  constructor(public id: number) {}
}

export class GetProfileSuccess implements Action {
  public readonly type = EProfileViewActions.GetProfileSuccess;

  constructor(public payload: IUser) {}
}

export class GetProfileFailure implements Action {
  public readonly type = EProfileViewActions.GetProfileFailure;

  constructor(public errors: IFormErrors) {}
}

export class UpdateProfileAvatar implements Action {
  public readonly type = EProfileViewActions.UpdateProfileAvatar;

  constructor(public payload: { detail: string; url: string }) {}
}

export class ClearGetProfile implements Action {
  public readonly type = EProfileViewActions.ClearGetProfile;
}

export type ProfileViewActions =
  | GetProfileRequest
  | GetProfileSuccess
  | GetProfileFailure
  | ClearGetProfile
  | UpdateProfileAvatar;
